export function normalizeUsername(value) {
  return String(value || '').trim().replace(/^@/, '').toLowerCase();
}

export function usernamePolicy(value, business = false) {
  const username = normalizeUsername(value);
  const minimum = business ? 8 : 6;
  const valid = new RegExp(`^[a-z0-9]{${minimum},15}$`).test(username);
  return {username, minimum, maximum: 15, valid};
}

export function passwordPolicy(value) {
  const password = String(value || '');
  const length = password.length >= 8 && password.length <= 21;
  const upper = /[A-Z]/.test(password);
  const lower = /[a-z]/.test(password);
  const number = /[0-9]/.test(password);
  const special = /[^A-Za-z0-9\s]/.test(password);
  const noSpaces = !/\s/.test(password);
  return {length, upper, lower, number, special, noSpaces,
    valid: length && upper && lower && number && special && noSpaces};
}

export const passwordRequirementLabels = [
  ['length', '8–21 characters'], ['upper', 'One capital letter'],
  ['lower', 'One small letter'], ['number', 'One number'],
  ['special', 'One special character'], ['noSpaces', 'No spaces']
];
